import { createPageLoadMetric, NOT_FOUND_LOAD_KEY } from '@confluence/browser-metrics';
export const NOT_FOUND_PAGE_LOAD = createPageLoadMetric({
	key: NOT_FOUND_LOAD_KEY,
});
